// tous les appels a 'fetch' ont ete changé pour etre executé depuis le serveur, ajouter un if ... quand ça marchera.
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

import { useState, useEffect } from 'react';

export function useStocks() {
    const [stocks, setStocks] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchStocks = async () => {
        try {
            setLoading(true);
            const response = await fetch('/stocktracker/api/stocks'); //fetch('http://localhost:8000/api/stocks');
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            setStocks(data.stocks || []);
        } catch (err) {
            console.error('Failed to load stocks:', err);
        } finally {
            setLoading(false);
        }
    };

    const addStock = async (stock) => {
        try {
            const response = await fetch('/stocktracker/api/stocks', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(stock)
            });

            const result = await response.json(); // Read once

            if (!response.ok) {
                throw new Error(result.detail || 'Failed to add stock');
            }

            setStocks(prev => [...prev, result]);
            return result;
        } catch (err) {
            console.error('Failed to add stock:', err);
            throw err; // Re-throw to show in UI
        }
    };

    useEffect(() => {
        fetchStocks();
    }, []);

    const removeStock = async (id) => {
        await fetch(`/stocktracker/api/stocks/${id}`, { method: 'DELETE' });
        fetchStocks(); // Refresh list
    };

    const refreshStock = async (id, stockData) => {
        try {
            const response = await fetch(`/stocktracker/api/stocks/${id}/refresh`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(stockData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.detail || 'Failed to refresh stock');
            }

            return await response.json();
        } catch (err) {
            console.error(`Failed to refresh stock ${id}:`, err);
            throw err;
        }
    };

    const editStock = async (id, { objective, watchlist }) => {
        try {
            // Convert empty string to null for objective
            const body = {
                objective: objective === '' ? null : objective,
                watchlist
            };

            const response = await fetch(`/stocktracker/api/stocks/${id}/edit`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body)
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.detail || 'Failed to update stock');
            }

            // Update local state immediately
            setStocks(prev => prev.map(s =>
                s.id === id ? { ...s, ...result } : s
            ));

            return result;
        } catch (err) {
            console.error('Failed to update stock:', err);
            throw err;
        }
    };

    return { stocks, loading, fetchStocks, addStock, removeStock, refreshStock, editStock };
}